import Button from '@widgets/Button';
import CommonIcon from '@teamwork/common-icons/dist/v-common-icon';
import { mapGetters } from 'vuex';
import Vue from 'vue';
import ImportOptions from '../../../data/onboarding/ImportOptions';
import IntegrationOptions from '../../../data/onboarding/IntegrationOptions';

// @vue/component
export default {
  components: {
    Button,
    CommonIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    leadText: {
      type: String,
      default: '',
    }, // include {0} for the app's name
    type: {
      type: String,
      required: true,
      validator: (value) => {
        return ['import', 'integrate'].includes(value);
      },
    },
  },
  data() {
    return {
      isModalOpen: false,
      hasDismissedAction: false,
    };
  },
  computed: {
    ...mapGetters({
      elpss: 'user/ellipsis',
    }),
    isImportMode() {
      return this.type === 'import';
    },
    imageBase() {
      return `//cdn-pjs.teamwork.com/tko/public/images/pages/settings${
        this.isImportMode ? '' : '/integration'
      }`;
    },
    typeAction() {
      return `${
        this.isImportMode
          ? Vue.t('Import from')
          : Vue.t(
              `Integrate with${this.preferences.length > 1 ? this.elpss : ''}`,
            )
      }`;
    },
    preferences() {
      return this.isImportMode
        ? this.$store.state.preferences.user.importOnboardingApp
        : this.$store.state.preferences.user.integrateOnboardingApp;
    },
    selectedOnboardingApp() {
      if (this.preferences.length === 0 || this.hasDismissedAction) {
        return null;
      }

      const options = this.isImportMode ? ImportOptions : IntegrationOptions;

      return this.preferences.map((app) => options[app]);
    },
    doAction() {
      return this.isImportMode ? this.toggleModal : this.goToAction;
    },
    subText() {
      return this.leadText.replace('{0}', this.selectedOnboardingApp[0].label);
    },
  },
  methods: {
    async close() {
      const prefs = this.isImportMode
        ? { importOnboardingApp: [] }
        : { integrateOnboardingApp: [] };

      this.$store.commit('preferences/change', {
        prefs,
        scope: 'user',
      });
      this.hasDismissedAction = true;
    },
    goToAction() {
      this.close();
      this.$parent.$emit('close-modal');
      this.$router.push(
        `/settings/${this.isImportMode ? 'import' : 'integrations'}`,
      );
    },
    toggleModal() {
      this.isModalOpen = !this.isModalOpen;
    },
  },
  mounted() {
    this.$parent.$on('close-modal', () => {
      this.isModalOpen = false;
    });
  },
};
